import { Link } from 'react-router-dom';
import { Trophy } from 'lucide-react';
import { AdminLayout } from '../../../components/layout/AdminLayout';
import { AwardTable } from '../../../components/admin/awards/AwardTable';
import { Button } from '../../../components/ui/button';
import { useCheckPermissions } from '../../../middleware/checkPermissions';

export const AwardList = () => {
  useCheckPermissions(['admin']);

  return (
    <AdminLayout>
      <div className="py-8 space-y-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col gap-6">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-4">
                <div className="relative">
                  <div className="absolute -inset-2 bg-gradient-to-r from-yellow-600 via-yellow-400 to-yellow-600 rounded-full blur opacity-75"></div>
                  <Trophy className="h-8 w-8 text-yellow-400 relative" />
                </div>
                <h1 className="text-2xl font-bold">
                  <span className="bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 text-transparent bg-clip-text">
                    Gestion des Awards
                  </span>
                </h1>
              </div>
              <Button asChild>
                <Link to="/admin/awards/new">
                  Créer un Award
                </Link>
              </Button>
            </div>

            <div className="space-y-4">
              <AwardTable />
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AwardList;
